import React, { useState, useEffect, useRef, useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/material.css";
import { useNavigate } from "react-router-dom";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";
import PhoneInput from "react-phone-input-2";
import { GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import axios from "axios";
import { io } from "socket.io-client";
import { CircularProgress } from "@mui/material";
import NoResultModal from "./NoResultModal";
import { Alert, Spin } from "antd";
import PlaceInput from "./PlaceInput";
import MapContainer from "../VehicleType/MapContainer";
import BookingLayout from "./BookingLayout";
import styled from "styled-components";
import VehicleSelection from "./VehicleSelection"; // Import the new component
import { OTPModal } from "./OTPVerificationModal";
import axiosInstance from "../../axiosInstance";
import DatePicker from "react-datepicker";

// Styled components remain unchanged
const DispatchContainer = styled.div`
  max-width: 100%;
  width: ${() => (window.innerWidth > 1024 ? "1200px" : "99%")};
  min-height: 5vh;
  margin: 0 auto;
  padding: 1rem;
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: ${() => (window.innerWidth > 1024 ? "1200px" : "100%")};
  margin: 0 auto;
`;

const SuccessCard = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  text-align: center;
  
  h3 {
    color: #16a34a;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    
    svg {
      color: #16a34a;
    }
  }
  
  .driver-info {
    background: #f0fdf4;
    border-radius: 0.75rem;
    padding: 1.5rem;
    margin-bottom: 2rem;
    border: 1px solid #86efac;
    text-align: left;
    
    p {
      margin: 0.75rem 0;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      
      svg {
        color: #16a34a;
      }
    }
  }
  
  .new-order-button {
    background: #1e40af;
    color: white;
    border: none;
    border-radius: 0.5rem;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    
    &:hover {
      background: #1e3a8a;
    }
  }
`;

const Dispatch = ({ socket }) => {
  const [paymentMethod, setPaymentMethod] = useState('Cash');
  const [dispatchMode, setDispatchMode] = useState("dispatch"); // dispatch | schedule
  const [scheduledPickupAt, setScheduledPickupAt] = useState(null);
  const [scheduleDateError, setScheduleDateError] = useState("");
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [corporateOtp, setCorporateOtp] = useState('');
  const [corporateRequestPayload, setCorporateRequestPayload] = useState(null);
  const [corporateOtpError, setCorporateOtpError] = useState('');
  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [startPoint, setStartPoint] = useState("");
  const [destiny, setDestiny] = useState("");
  const [phone, setPhone] = useState("");
  const [user, setUser] = useState("");
  const [startPointError, setStartPointError] = useState("");
  const [destinyError, setDestinyError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [userError, setUserError] = useState("");
  const [acceptedDriverData, setAcceptedDriverData] = useState();
  const [map, setMap] = useState(null);
  const startPlaceLocation = useRef({});
  const destinyLocation = useRef({});
  const [polylineOptions, setPolylineOptions] = useState(null);
  const [mapOptions, setMapOptions] = useState({
    zoom: 10,
    center: { lat: 9.005401, lng: 38.763611 },
  });
  const [showForm, setShowForm] = useState("form");
  const [showLoading, setShowLoading] = useState(false);
  const [tripAcepted, setTripAcepted] = useState(false);
  const [passengerId, setPassengerId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mapKey, setMapKey] = useState(0);
  const [vehicle, setVehicle] = useState([]);

  const resetState = () => {
    setStartPoint("");
    setDestiny("");
    setPhone("");
    setUser("");
    setStartPointError("");
    setDestinyError("");
    setPhoneError("");
    setUserError("");
    setAcceptedDriverData(null);
    setVehicle([]);
    setMapKey((prev) => prev + 1);
    setDispatchMode("dispatch");
    setScheduledPickupAt(null);
    setScheduleDateError("");
    startPlaceLocation.current = {};
    destinyLocation.current = {};
    setMapOptions({
      zoom: 10,
      center: { lat: 9.005401, lng: 38.763611 },
    });
  };

  useEffect(() => {
    console.log("=======socket response detected========")

    const handleEstimatedPrice = (data) => {
      console.log("+++++++estimatedPrice+++++data+++", data);
      let vehicles = [];
      setPassengerId(data.passengerId);
      data.byVehicleType.map((veh) => {
        vehicles.push({
          id: veh.id,
          typeName: veh.typeName,
          estimatedPrice: veh.estimatedPrice,
          estimatedTime: data.eta,
          distance: data.distance,
          imageUrl: "/car/economyCar.jpg",
        });
      });
      setShowLoading(false);
      setShowForm("vehicle");
      setVehicle(vehicles);
    };

    const handleNoResults = (data) => {
      if (showForm !== "success") {
        setLoading(false);
        setShowLoading(false);
        // Return to vehicle selection so dispatcher can retry without re-filling the form
        setShowForm("vehicle");
        setIsModalOpen(true);
      }
    };

    const handleRequestAccepted = (data) => {
      console.log("+++++++requestAccepted++++", data);
      setAcceptedDriverData(data);
      setLoading(false);
      setShowForm("success");
      socket.off("noResults", handleNoResults);
      console.log("Removed noResults listener after successful acceptance");
    };

    const handleReservationAccepted = (data) => {
      console.log("+++++++reservationAccepted++++", data);
      setAcceptedDriverData(data);
      setShowLoading(false);
      setLoading(false);
      setShowForm("success");
      toast.success("Reservation accepted.");
      socket.off("noResults", handleNoResults);
    };

    // -- CORP: On corporateOtpSentWeb --
    const handleCorporateOtpSentWeb = (data) => {
      setLoading(false);
      setOtpModalOpen(true);
      setCorporateOtpError('');
      if (data?.originalRequestData) {
        setCorporateRequestPayload(data.originalRequestData);
      }
    };
    // -- CORP: verification success --
    const handleCorporateVerificationSuccessWeb = (data) => {
      setOtpModalOpen(false);
      setCorporateOtp('');
      setCorporateOtpError('');
      setLoading(true);
    };
    // -- Corp/general error --
    const handleError = (err) => {
      setCorporateOtpError(err.message || err.error || 'Unknown error');
      setOtpModalOpen(false);
      setLoading(false);
      if (typeof err === 'string') toast.error(err);
      else if(err?.message) toast.error(err.message);
      else toast.error('Error occurred');
    };

    socket.on("estimatedPrice", handleEstimatedPrice);
    socket.on("noResults", handleNoResults);
    socket.on("requestAccepted", handleRequestAccepted);
    socket.on("reservationAccepted", handleReservationAccepted);
    socket.on("corporateOtpSentWeb", handleCorporateOtpSentWeb);
    socket.on("corporateVerificationSuccessWeb", handleCorporateVerificationSuccessWeb);
    socket.on("error", handleError);

    return () => {
      socket.off("estimatedPrice", handleEstimatedPrice);
      socket.off("noResults", handleNoResults);
      socket.off("requestAccepted", handleRequestAccepted);
      socket.off("reservationAccepted", handleReservationAccepted);
      socket.off("corporateOtpSentWeb", handleCorporateOtpSentWeb);
      socket.off("corporateVerificationSuccessWeb", handleCorporateVerificationSuccessWeb);
      socket.off("error", handleError);
    };
  }, [socket, showForm]);

  const handleMapLoad = (map) => {
    setMap(map);
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
      console.log("========handleSubmit===1=");

    if (dispatchMode === "schedule") {
      setScheduleDateError("");
      if (!scheduledPickupAt) {
        setScheduleDateError("Pickup date/time is required");
        return;
      }
    }

    // Basic input validation
    if (startPoint === "" || destiny === "" || phone === "") {
      if (startPoint === "") setStartPointError("Starting point required");
      if (destiny === "") setDestinyError("Destination required");
      if (phone === "") setPhoneError("Phone required");
      console.log("========handleSubmit===2=");

      return;
    }

    // Normalize phone for validation (strip leading + if present)
    const normalizedPhone = phone.startsWith("+") ? phone.slice(1) : phone;

    // Phone number validation
    if (
      !normalizedPhone.startsWith("251") &&
      !normalizedPhone.startsWith("09") &&
      !normalizedPhone.startsWith("07")
    ) {
      setPhoneError("Invalid phone number");
      console.log("========handleSubmit===3=");

      return;
    }

    if (normalizedPhone.startsWith("251") && normalizedPhone.length !== 12) {
      setPhoneError("Invalid phone number");
      return;
    }

    if (
      (normalizedPhone.startsWith("09") || normalizedPhone.startsWith("07")) &&
      normalizedPhone.length !== 10
    ) {
      setPhoneError("Invalid phone number");
      return;
    }
    console.log("========handleSubmit===4=");

    console.log("=====startPlaceLocation========", startPlaceLocation.current);
    // Check if geocoding was successful
    if (
      !startPlaceLocation.current.lat ||
      !startPlaceLocation.current.lng
    ) {
      setStartPointError("Failed to locate starting point");
      setShowLoading(false);
      return;
    }

    if (
      !destinyLocation.current.lat ||
      !destinyLocation.current.lng
    ) {
      setDestinyError("Failed to locate destination");
      setShowLoading(false);
      return;
    }

    if (!socket || !socket.connected) {
      toast.error("No connection to dispatch service. Please refresh.");
      return;
    }

    setShowLoading(true);

    // Both dispatch-now and schedule modes: get price estimates first so user can pick vehicle type
    const data = {
      pickUpLocationLatitude: startPlaceLocation.current.lat.toString(),
      pickUpLocationLongitude: startPlaceLocation.current.lng.toString(),
      destinationLocationLatitude: destinyLocation.current.lat.toString(),
      destinationLocationLongitude: destinyLocation.current.lng.toString(),
      pickUpPlaceName: startPoint,
      destinationPlaceName: destiny,
    };

    console.log("=====data====getEstimatedPriceWeb====", data);
    socket.emit("getEstimatedPriceWeb", data);
  };

  const handleStartPointChange = useCallback(async (value) => {
    setStartPointError("");
    setStartPoint(value);
    const address = value;
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      startPlaceLocation.current = latLng;
      setMapOptions((prev) => ({
        ...prev,
        startPoint: latLng,
      }));
    } catch (error) {
      console.error("Error fetching geolocation:", error);
      setStartPointError("Failed to locate starting point");
      startPlaceLocation.current = {}; // Reset to avoid partial data
    }
  }, []);

  const handleDestinyChange = useCallback(async (value) => {
    setDestinyError("");
    setDestiny(value);
    const address = value;
    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      destinyLocation.current = latLng;
      setMapOptions((prev) => ({
        ...prev,
        destination: latLng,
      }));
    } catch (error) {
      console.error("Error fetching geolocation:", error);
      setDestinyError("Failed to locate destination");
      destinyLocation.current = {}; // Reset to avoid partial data
    }
  }, []);

  const handlePhoneChange = (value) => {
    setPhoneError("");
    // Ensure phone always starts with '+' when stored
    const valWithPlus = value ? (value.startsWith("+") ? value : "+" + value) : value;
    setPhone(valWithPlus);
  };

  const vehicleClicked = async (id) => {
    // Guard: immediately switch to searching screen to prevent double-clicks / double-emits
    setShowForm("searching");

    const normalizedPhone = (phone || '').startsWith('+') ? phone : `+${phone}`;

    if (dispatchMode === "schedule") {
      // Scheduled booking — resolve passenger then emit reservation with selected vehicleTypeId
      try {
        const passengerRes = await axiosInstance.get("/passengers/by-phone", {
          params: { phoneNumber: normalizedPhone },
        });
        const passengerIdResolved = passengerRes?.data?.passenger?.id;
        if (!passengerIdResolved) {
          toast.error("Passenger not found for this phone number");
          setShowForm("vehicle"); // return to vehicle selection on error
          return;
        }

        const payload = {
          passengerId: passengerIdResolved,
          pickUpLocationLatitude: startPlaceLocation.current.lat.toString(),
          pickUpLocationLongitude: startPlaceLocation.current.lng.toString(),
          destinationLocationLatitude: destinyLocation.current.lat.toString(),
          destinationLocationLongitude: destinyLocation.current.lng.toString(),
          vehicleTypeId: id.toString(),
          pickUpDate: scheduledPickupAt.toISOString(),
          destinationLocationName: destiny,
          paymentMethod,
        };

        socket.emit("reservation", JSON.stringify(payload));
        toast.info("Searching for a driver to accept the scheduled booking...");
      } catch (error) {
        setShowForm("vehicle"); // return to vehicle selection on error
        const msg =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Failed to schedule reservation";
        toast.error(msg);
      }
      return;
    }

    // Dispatch Now — corporate or normal
    if (paymentMethod === 'Corporate') {
      const corpPayload = {
        pickUpLocationLatitude: startPlaceLocation.current.lat.toString(),
        pickUpLocationLongitude: startPlaceLocation.current.lng.toString(),
        destinationLocationLatitude: destinyLocation.current.lat.toString(),
        destinationLocationLongitude: destinyLocation.current.lng.toString(),
        vehicleTypeId: id.toString(),
        phone: normalizedPhone,
        rideSharing: "Off",
        passengerId: passengerId,
        destinationPlaceName: destiny,
        paymentMethod: 'Corporate'
      };
      setCorporateRequestPayload(corpPayload);
      socket.emit("requestWeb", corpPayload);
      return;
    }

    // Normal dispatch-now — already on "searching" screen
    const data = {
      pickUpLocationLatitude: startPlaceLocation.current.lat.toString(),
      pickUpLocationLongitude: startPlaceLocation.current.lng.toString(),
      destinationLocationLatitude: destinyLocation.current.lat.toString(),
      destinationLocationLongitude: destinyLocation.current.lng.toString(),
      vehicleTypeId: id.toString(),
      phone: normalizedPhone,
      rideSharing: "Off",
      passengerId: passengerId,
      destinationPlaceName: destiny,
      paymentMethod,
    };
    socket.emit("requestWeb", data);
  };

  const handleNewOrder = () => {
    resetState();
    setShowForm("form");
  };

  return (
    <>
      <NoResultModal
        click={() => setIsModalOpen(false)}
        msg={"Message"}
        modalOpen={isModalOpen}
        setModalOpen={setIsModalOpen}
      >
        <Alert
          message="No accepted Driver found please try again!"
          type="error"
        />
      </NoResultModal>

      {loading && (
        <NoResultModal
          msg={"Finding driver..."}
          fotter={true}
          cancel={true}
          modalOpen={loading}
          setModalOpen={setLoading}
        >
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Spin size="large" />
          </div>
        </NoResultModal>
      )}

      {/* CORPORATE OTP MODAL */}
    
  <OTPModal
        isOpen={otpModalOpen}
        onClose={() => {
          setOtpModalOpen(false);
          setCorporateOtp('');
          setCorporateOtpError('');
        }}
        onVerify={(otpValue) => {
          if (!corporateRequestPayload) {
            setCorporateOtpError('Internal state error. Try again.');
            return;
          }
          setCorporateOtpError('');
          setLoading(true);
          setOtpModalOpen(false);
          socket.emit("verifyCorporateTripWeb", {
            verificationCode: otpValue,
            originalRequestData: corporateRequestPayload,
          });
        }}
        error={corporateOtpError}
        loading={loading}
        phoneNumber={phone}
      />
      <DispatchContainer>
        <ToastContainer />
        <div>
          {showForm === "form" && (
            <BookingLayout
              startPoint={startPoint}
              startPointError={startPointError}
              destiny={destiny}
              destinyError={destinyError}
              phone={phone}
              phoneError={phoneError}
              showLoading={showLoading}
              handleSubmit={handleSubmit}
              submitLabel={dispatchMode === "schedule" ? "Schedule Booking" : "Continue"}
              hidePaymentMethods={dispatchMode === "schedule"}
              extraFields={
                <>
                  <div style={{ marginTop: "14px" }}>
                    <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
                      <button
                        type="button"
                        onClick={() => {
                          setDispatchMode("dispatch");
                          setScheduleDateError("");
                        }}
                        style={{
                          flex: 1,
                          border: "1px solid #e2e8f0",
                          background: dispatchMode === "dispatch" ? "#1e40af" : "#ffffff",
                          color: dispatchMode === "dispatch" ? "#ffffff" : "#0f172a",
                          borderRadius: "8px",
                          padding: "10px 12px",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Dispatch Now
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setDispatchMode("schedule");
                        }}
                        style={{
                          flex: 1,
                          border: "1px solid #e2e8f0",
                          background: dispatchMode === "schedule" ? "#1e40af" : "#ffffff",
                          color: dispatchMode === "schedule" ? "#ffffff" : "#0f172a",
                          borderRadius: "8px",
                          padding: "10px 12px",
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Schedule Booking
                      </button>
                    </div>

                    {dispatchMode === "schedule" && (
                      <div style={{ marginTop: "10px" }}>
                        <div style={{ fontWeight: 600, marginBottom: "6px", color: "#0f172a" }}>
                          Pickup Date & Time
                        </div>
                        <DatePicker
                          selected={scheduledPickupAt}
                          onChange={(d) => {
                            setScheduleDateError("");
                            setScheduledPickupAt(d);
                          }}
                          showTimeSelect
                          timeIntervals={15}
                          timeCaption="Time"
                          dateFormat="MMMM d, yyyy h:mm aa"
                          minDate={new Date()}
                          placeholderText="Select pickup date/time"
                          className="form-control"
                        />
                        {scheduleDateError ? (
                          <div style={{ color: "#dc2626", fontSize: "0.85rem", marginTop: "6px" }}>
                            {scheduleDateError}
                          </div>
                        ) : null}
                      </div>
                    )}
                  </div>
                </>
              }
              handleStartPointChange={handleStartPointChange}
              handleDestinyChange={handleDestinyChange}
              handlePhoneChange={handlePhoneChange}
              setStartPoint={setStartPoint}
              setStartPointError={setStartPointError}
              setDestiny={setDestiny}
              setDestinyError={setDestinyError}
              mapKey={mapKey}
              setPaymentMethod={setPaymentMethod}
              paymentMethod={paymentMethod}
            />
          )}
          {showForm === "vehicle" && (
            <VehicleSelection 
              vehicles={vehicle}
              onVehicleSelect={vehicleClicked}
              onBack={() => setShowForm("form")}
            />
          )}

          {/* Searching screen — shown after vehicle is picked, before a driver accepts */}
          {showForm === "searching" && (
            <div style={{
              background: "white",
              borderRadius: "1rem",
              padding: "3rem 2rem",
              boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)",
              textAlign: "center",
              maxWidth: 480,
              margin: "0 auto",
            }}>
              <Spin size="large" style={{ marginBottom: 24 }} />
              <h3 style={{ color: "#1e40af", marginBottom: 8, fontSize: "1.25rem" }}>
                Searching for a driver…
              </h3>
              <p style={{ color: "#64748b", marginBottom: 28, fontSize: "0.9rem" }}>
                Please wait while we find the nearest available driver.
              </p>
              <button
                onClick={() => {
                  setShowForm("vehicle");
                  setLoading(false);
                }}
                style={{
                  background: "#f1f5f9",
                  color: "#475569",
                  border: "none",
                  borderRadius: "0.5rem",
                  padding: "10px 24px",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontSize: "0.9rem",
                }}
              >
                ← Back to Vehicle Selection
              </button>
            </div>
          )}

          {showForm === "success" && (
            <SuccessCard>
              <h3>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                {dispatchMode === "schedule" ? "Reservation accepted" : "Dispatched successfully"}
              </h3>
              <div className="driver-info">
                <p>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                  {dispatchMode === "schedule"
                    ? "Driver will arrive at the scheduled time"
                    : "Driver is on the way"}
                </p>
                <p>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Driver Name: {acceptedDriverData?.driver?.firstName}{" "}
                  {acceptedDriverData?.driver?.lastName}
                </p>
                <p>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  Driver phone: {acceptedDriverData?.driver?.phoneNumber}
                </p>
                <p>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="3" width="15" height="13"/>
                    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
                    <circle cx="5.5" cy="18.5" r="2.5"/>
                    <circle cx="18.5" cy="18.5" r="2.5"/>
                  </svg>
                  Vehicle plate number: {acceptedDriverData?.vehicle?.plateNumber}
                </p>
              </div>
              <button className="new-order-button" onClick={handleNewOrder}>
                Dispatch New Order
              </button>
            </SuccessCard>
          )}
        </div>
      </DispatchContainer>
    </>
  );
};

export default Dispatch;
